import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { LoginComponent } from './pages/login/login.component';
import { SignupComponent } from './pages/signup/signup.component';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';

import { ChatComponent } from './pages/chat/chat.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';

import { ChatResolverService } from './pages/chat/services/chat-resolver.service';
import { AuthGuardService } from './services/auth-guard.service';


const appRoutes: Routes = [
  // { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: '', component: LandingPageComponent,
    children: [
      { path: '', component: LoginComponent },
      { path: 'login', component: LoginComponent },
      { path: 'signup', component: SignupComponent },
      { path: 'forgot-password', component: ForgotPasswordComponent }
    ]
  },
  {
    path: 'chat', component: ChatComponent,
      canActivate: [AuthGuardService] ,
      canActivateChild: [AuthGuardService],
      resolve: {
        user: ChatResolverService
      },
  },
  { path: '**', component: PageNotFoundComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule]
})

export class AppRoutingModule {
}



// resolve: {
//   user: ChatResolverService
// },


// WEBPACK FOOTER //
// ./src/app/app.routes.ts